import PropTypes from 'prop-types';
import { Component } from 'react';
import ErrorsTooltipContent from './ErrorsTooltipContent';
import WarningsTooltipContent from './WarningsTooltipContent';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EMPTY_ARRAY = [];
class ErrorsAndWarningsTooltip extends Component {
  renderTooltipContent() {
    const {
      errors,
      onErrorFocus,
      missingVariantCategoryLanguages,
      missingVariantSubcategoryLanguages,
      warnings
    } = this.props;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ErrorsTooltipContent, {
        errors: errors,
        onErrorFocus: onErrorFocus,
        missingVariantCategoryLanguages: missingVariantCategoryLanguages,
        missingVariantSubcategoryLanguages: missingVariantSubcategoryLanguages
      }), /*#__PURE__*/_jsx(WarningsTooltipContent, {
        warnings: warnings
      })]
    });
  }
  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'children' does not exist on type 'Readon... Remove this comment to see the full error message
    const {
      children,
      errors,
      warnings
    } = this.props;
    const hasErrors = errors.length > 0;
    const hasWarnings = warnings.length > 0;
    return /*#__PURE__*/_jsx(View, {
      backgroundColor: 'fill-surface-default',
      children: /*#__PURE__*/_jsx(Tooltip, {
        disabled: !hasErrors && !hasWarnings,
        placement: "bottom left",
        title: this.renderTooltipContent(),
        use: "longform"
        // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
        ,
        zIndex: parseInt(1211, 10),
        children: children
      })
    });
  }
}
ErrorsAndWarningsTooltip.defaultProps = {
  errors: EMPTY_ARRAY,
  warnings: EMPTY_ARRAY
};
ErrorsAndWarningsTooltip.propTypes = {
  children: PropTypes.element.isRequired,
  errors: PropTypes.array.isRequired,
  onErrorFocus: PropTypes.func.isRequired,
  missingVariantCategoryLanguages: PropTypes.arrayOf(PropTypes.string),
  missingVariantSubcategoryLanguages: PropTypes.arrayOf(PropTypes.string),
  warnings: PropTypes.array
};
export default ErrorsAndWarningsTooltip;